import debounce from 'lodash.debounce';
import { useEffect, useMemo } from 'react';

export const useDebouncedEffect = <D extends unknown[]>(
  effect: (...args: D) => void,
  delay: number,
  dependencies: D
) => {
  const debouncedEffect = useMemo(
    () => debounce((...args: D) => effect(...args), delay),
    [delay, effect]
  );

  useEffect(() => {
    debouncedEffect(...dependencies);

    return () => debouncedEffect.cancel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedEffect, ...dependencies]);
};
